import React, { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Clock, LogOut, Building2 } from 'lucide-react';
import logo from '../../assets/logo.png';
import toast from 'react-hot-toast';

// Écran affiché tant que le compte gérant n'est pas validé par l'admin
// (statutValidation !== 'validé'). Écoute son propre document en temps réel
// pour débloquer automatiquement l'accès dès que l'admin valide, sans que le
// gérant ait besoin de se reconnecter (pas de Cloud Function/email sur le
// plan Spark — l'équivalent le plus proche d'une notification instantanée).
export default function GerantEnAttente() {
  const { currentUser, userProfile, fetchUserProfile, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.uid) return;
    const unsub = onSnapshot(doc(db, 'users', currentUser.uid), snap => {
      const statut = snap.data()?.statutValidation;
      if (statut === 'validé') {
        fetchUserProfile(currentUser.uid);
      }
    });
    return () => unsub();
  }, [currentUser?.uid, fetchUserProfile]);

  async function handleLogout() {
    await logout();
    toast.success('Déconnecté');
    navigate('/');
  }

  const refuse = userProfile?.statutValidation === 'refusé';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(180deg, #1B4F72 0%, #2d7ab5 35%, #e8f0f8 70%, #F8F9FA 100%)',
      padding: '1.5rem',
    }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem 2rem', maxWidth: 440, width: '100%', textAlign: 'center', boxShadow: '0 24px 80px rgba(27,79,114,0.18)' }}>
        <img src={logo} alt="ResiPro CI" style={{ width: 60, height: 60, borderRadius: 14, objectFit: 'contain', margin: '0 auto 1.25rem', display: 'block' }} />

        <div style={{
          width: 64, height: 64, borderRadius: '50%', margin: '0 auto 1.25rem',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: refuse ? '#fde8e8' : '#fef3d7',
        }}>
          {refuse ? <Building2 size={30} color="var(--danger)" /> : <Clock size={30} color="var(--secondary)" />}
        </div>

        {refuse ? (
          <>
            <h2 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>Inscription refusée</h2>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              Votre demande de compte gérant n'a pas été validée par notre équipe.
              Contactez le support si vous pensez qu'il s'agit d'une erreur.
            </p>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>Compte en attente de validation</h2>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              Merci {userProfile?.prenom} ! Votre compte gérant sera activé après vérification
              par notre équipe. Cette page se mettra à jour automatiquement dès validation.
            </p>
          </>
        )}

        <button className="btn btn-outline w-full" onClick={handleLogout}>
          <LogOut size={16} /> Déconnexion
        </button>
      </div>
    </div>
  );
}
